var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column type-checkbox"},[(_vm.isTrue())?_c('v-icon',[_vm._v("$vuetify.icons.checkboxOn")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }